import React, {Component, Fragment, PureComponent} from 'react';

import {ListView} from 'antd-mobile';
import PublicHeader from './../../components/header/index';
import {connect} from 'react-redux';
import {getSpaceList} from './store/actionCreators';

class SpaceList extends PureComponent {

    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
        };

        this.props.getSpaceList();
    }

    render() {
        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: '#F5F5F9',
                    height: 8,
                    borderTop: '1px solid #ECECED',
                    borderBottom: '1px solid #ECECED',
                }}
            />
        );

        const {spaceList = []} = this.props.spaceList;
        let index = spaceList.length - 1;

        const row = (rowData, sectionID, rowID) => {
            if (index < 0) {
                index = spaceList.length - 1;
            }
            const obj = spaceList[index--];
            return (
                <div key={rowID} style={{padding: '0 15px'}} data-id={obj.id}>
                </div>
            );
        };

        return (
            <Fragment>
                <PublicHeader title="消费记录"/>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={this.state.dataSource}
                    renderFooter={() => (<div style={{padding: 30, textAlign: 'center'}}>
                        {this.state.isLoading ? '加载中...' : '加载完成'}
                    </div>)}
                    renderRow={row}
                    renderSeparator={separator}
                    className="am-list"
                    pageSize={4}
                    useBodyScroll
                    onScroll={() => {
                        console.log('scroll');
                    }}
                    scrollRenderAheadDistance={500}
                    onEndReachedThreshold={10}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (data) => {
    return {
        spaceList: data
    }
};

const mapDispatchToProps = (dispatch) => ({
    getSpaceList: (id) => dispatch(getSpaceList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SpaceList);
